export class Payment {
    Amount: string = '';
    BankAccountID: string = '';
    BankAccountName: string = '';
    BankRoutingNumber: string = '';
    BankAccountNumber: string = '';
    BankAccountType: string = '';
    CreditCardPaymentMethodId: string = '';
    CreditCardAuthorized: boolean = false;
    CreditCardFee: string = '';
    CreditCardPaymentId: string = '';
    PaymentMethodIdentifier: string = '';
    BillingAccountID: string = '';
    BillingAccountName: string = '';
    Date: string = '';
    ReturnedDate: string = '';
    ReturnedReason: string = '';
    ID: string = '';
    Num: string = '';
    RequestID: string = '';
    Status: string = '';
    Type: string = '';
    SelectedPaymentMethod: string = '';
}